import React, { useState, useEffect } from 'react';

interface LoadingDotsProps {
  text?: string;
  style?: React.CSSProperties;
}

const LoadingDots: React.FC<LoadingDotsProps> = ({
  text = 'Sicherheitsprüfung läuft',
  style = {}
}) => {
  const [dotCount, setDotCount] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setDotCount(prev => (prev + 1) % 4);
    }, 500);

    return () => clearInterval(interval);
  }, []);

  const dots = '.'.repeat(dotCount).padEnd(3, ' ');

  return (
    <span
      style={{
        ...style,
        display: 'inline-flex',
        alignItems: 'center',
        height: '1.2em',
        lineHeight: '1.2em'
      }}
    >
      {text}
      <span
        style={{
          fontFamily: 'monospace',
          minWidth: '3ch',
          display: 'inline-block',
          letterSpacing: '-0.2em',
          textAlign: 'left'
        }}
      >
        {dots}
      </span>
    </span>
  );
};

export default LoadingDots;
